module.exports = __webpack_public_path__ + "d8ef25518b0c6eaddae8aa3fc58db4e6.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/icon_multimedia.gif
// module id = 692
// module chunks = 0